import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import _isEmpty from 'lodash/isEmpty';
import _size from 'lodash/size';
import ACTION_TYPES from './withSelectionSummary.actionTypes';
import SelectionSummary from '../../molecules/selectionSummary';
export var getTableManagerProps = function getTableManagerProps(tableManagerProps, selection) {
  var isSelectionEmpty = _isEmpty(selection);
  return _objectSpread(_objectSpread({}, tableManagerProps), {}, {
    showFilter: isSelectionEmpty,
    showSearch: isSelectionEmpty,
    showSearchByField: isSelectionEmpty,
    showRefreshIcon: isSelectionEmpty,
    showTotalCount: isSelectionEmpty,
    showSubHeader: true
  });
};
var getSubHeaderLeftActions = function getSubHeaderLeftActions(selection) {
  return [{
    renderer: SelectionSummary,
    action: ACTION_TYPES.CLEAR_SELECTION,
    renderOptions: {
      selectionCount: _size(selection)
    }
  }];
};
var getSubHeaderPropsOverrides = function getSubHeaderPropsOverrides(baseSubHeaderProps, getSubHeaderPropsForSelection) {
  return _objectSpread(_objectSpread({}, baseSubHeaderProps), getSubHeaderPropsForSelection());
};
export var getSubHeaderProps = function getSubHeaderProps(subHeaderProps, selection, getSubHeaderPropsForSelection) {
  var baseSubHeaderProps = _objectSpread(_objectSpread({}, subHeaderProps), {}, {
    subHeaderLeftActions: getSubHeaderLeftActions(selection)
  });
  var subHeaderPropsOverrides = getSubHeaderPropsOverrides(baseSubHeaderProps, getSubHeaderPropsForSelection);
  return subHeaderPropsOverrides;
};